export default __webpack_public_path__ + "static/media/DNo.23-4.820806d4.jpg";